export const COOKIE_NAME = {
  NAVBAR_TOOLTIP_SNOOZED: 'navbar_tooltip_snoozed',
  PROMOTIONAL_INTEGRATION_BANNER: 'promotional_integration_banner',
  INTEGRATION_SETUP: 'integration_setup',
  SAVE_YOUR_CUSTOMERS_INFORMATION_CLOSED: 'save_your_customers_information_closed',
  AKS_BANNER_CLOSED: 'aks_banner_closed',
  PREFERRED_CATEGORIES_EDITOR_SAVED: 'preferred_categories_editor_saved',
};
